'use client';

import React from 'react';

import ButtonLink from './ButtonLink';

const MoneyResources: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto py-12 px-4 mt-12">
      <h2 className="text-2xl font-bold text-center mb-8 text-gray-800 dark:text-white transition-colors duration-300">
        省錢資源推薦
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
          <div className="p-5 flex flex-col h-full">
            <div className="flex items-center mb-3">
              <span className="text-2xl mr-2">💡</span>
              <h3 className="font-semibold text-gray-800 dark:text-white">理財社群</h3>
            </div>
            <p className="text-gray-600 dark:text-gray-300 text-sm mb-4 flex-grow">
              加入理財社群討論，獲取最新優惠資訊和理財建議
            </p>
            <ButtonLink
              link={'https://www.dcard.tw/f/money'}
              className="bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-400 text-white px-4 py-2 rounded-lg text-sm w-full text-center transition-colors duration-300"
            >
              Dcard 理財版
            </ButtonLink>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
          <div className="p-5 flex flex-col h-full">
            <div className="flex items-center mb-3">
              <span className="text-2xl mr-2">🏷️</span>
              <h3 className="font-semibold text-gray-800 dark:text-white">優惠碼</h3>
            </div>
            <p className="text-gray-600 dark:text-gray-300 text-sm mb-4 flex-grow">
              各大電商、外送平台最新優惠碼整理
            </p>
            <ButtonLink
              link={'https://couponmad.xyz/'}
              className="bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-400 text-white px-4 py-2 rounded-lg text-sm w-full text-center transition-colors duration-300"
            >
              CouponMad
            </ButtonLink>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
          <div className="p-5 flex flex-col h-full">
            <div className="flex items-center mb-3">
              <span className="text-2xl mr-2">📊</span>
              <h3 className="font-semibold text-gray-800 dark:text-white">股票投資</h3>
            </div>
            <p className="text-gray-600 dark:text-gray-300 text-sm mb-4 flex-grow">
              台股ETF、美股投資策略與分析資源
            </p>
            <ButtonLink
              link={'https://www.cmoney.tw/'}
              className="bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-400 text-white px-4 py-2 rounded-lg text-sm w-full text-center transition-colors duration-300"
            >
              CMoney 理財寶
            </ButtonLink>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
          <div className="p-5 flex flex-col h-full">
            <div className="flex items-center mb-3">
              <span className="text-2xl mr-2">💰</span>
              <h3 className="font-semibold text-gray-800 dark:text-white">理財工具</h3>
            </div>
            <p className="text-gray-600 dark:text-gray-300 text-sm mb-4 flex-grow">
              記帳、投資組合追蹤與理財規劃工具
            </p>
            <ButtonLink
              link={'https://www.moneydj.com/'}
              className="bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-400 text-white px-4 py-2 rounded-lg text-sm w-full text-center transition-colors duration-300"
            >
              MoneyDJ 理財網
            </ButtonLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoneyResources;
